import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
export function BreadcrumbSection() {
  return <div className="bg-white border-b border-gray-200" data-id="element-3508">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4" data-id="element-3509">
        <div className="flex items-center text-sm text-gray-500" data-id="element-3510">
          <a href="/" className="hover:text-orange transition-colors" data-id="element-3511">
            Home
          </a>
          <ChevronRightIcon className="w-4 h-4 mx-2" data-id="element-3512" />
          <a href="/SpinnerMachineTools.html" className="hover:text-orange transition-colors" data-id="element-3513">
            Products
          </a>
          <ChevronRightIcon className="w-4 h-4 mx-2" data-id="element-3514" />
          <span className="text-navy font-semibold" data-id="element-3515">SPINNER PD</span>
        </div>
      </div>
    </div>;
}